import { useEffect } from "react";

// CMP member pages: design font sizing and bold weight (index.css body.cmp-member-shell).
// Counted, so the login page and the signed-in shell never remove each other's class.
let users = 0;

const useCmpMemberShellClass = (active: boolean) => {
  useEffect(() => {
    if (!active) return undefined;
    users += 1;
    document.body.classList.add("cmp-member-shell");
    return () => {
      users -= 1;
      if (users <= 0) {
        users = 0;
        document.body.classList.remove("cmp-member-shell");
      }
    };
  }, [active]);
};

export default useCmpMemberShellClass;
